import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RotateCcw } from 'lucide-react';

export class ElementErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error) { console.error('Element render error:', error); }
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 rounded-xl border border-amber-300 bg-amber-50 text-center space-y-3" data-testid="element-error-fallback">
          <AlertTriangle className="h-8 w-8 text-amber-500 mx-auto" />
          <p className="text-sm font-medium text-amber-900">Oops, something went wrong loading this section.</p>
          <p className="text-xs text-amber-800">Your progress is safe. Try again, or move on and come back later.</p>
          <Button variant="outline" size="sm" className="min-h-[44px]" onClick={() => this.setState({ hasError: false })} data-testid="element-error-retry-btn">
            <RotateCcw className="h-4 w-4 mr-2" /> Retry
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
